import { ADMIN_USER_ID, storageEngine } from 'utilities/integration/rails';

export const getAdminUserID = () => storageEngine.getItem(ADMIN_USER_ID);

export default getAdminUserID;
